// Every permission string the API knows (API.md "Permission strings").
export const PERMISSIONS = {
  usersRead: "users.read",
  usersWrite: "users.write",
  rolesManage: "roles.manage",
  scopesManage: "scopes.manage",
  auditRead: "audit.read",
  nodesRead: "nodes.read",
  nodesWrite: "nodes.write",
  blacklistRead: "rules.blacklist.read",
  blacklistWrite: "rules.blacklist.write",
  blacklistPermanent: "rules.blacklist.permanent",
  blacklistTTLWrite: "rules.blacklist.ttl.write",
  whitelistRead: "rules.whitelist.read",
  whitelistWrite: "rules.whitelist.write",
  pamRead: "pam.read",
  pamWrite: "pam.write",
  aliasesRead: "aliases.read",
  aliasesWrite: "aliases.write",
  feedsRead: "feeds.read",
  feedsWrite: "feeds.write",
  filtersRead: "filters.read",
  filtersWrite: "filters.write",
  metricsRead: "metrics.read",
  ddosRead: "ddos.read",
  telemetryRead: "telemetry.read",
  licensesRead: "licenses.read",
  licensesWrite: "licenses.write",
  securitySettingsRead: "settings.security.read",
  securitySettingsWrite: "settings.security.write",
} as const;

export type KnownPermission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
